import { BaseModel } from 'src/app/shared/models/base.model';

export class Service extends BaseModel{
    static fromJsonToObject(jsonData:any):Service{
        return Object.assign(new Service(),jsonData);
    }
}